import HTMLTemplate from './template.html'
import './styles.scss'
import { cloneDeep } from 'lodash'
import User from '../../modules/user'
import { REPORT, REPORT_FILTER } from './BriefBuilderData'
import moment from 'moment'
import ClientPortalAPIService from './../../services/api/ClientPortal/ApiService'
import MixPanelService from '../../services/MixPanelService'

export const BriefBuilderComponent = (() => {
    const vueComponent = {
        data() {
            return {
                reportType: null,
                reportObject: {},
                selectedSubCategory: {},
                reportTypes: ['airport', 'city', 'country', 'airspace'],
                selectMainCategoryIndex: '',
                availableData: {},
                isExportButtonDisable: false,
                isDownloadingReport: false,
                isDownloadReportHasError: false,
                previousReport: null,
                isPreviousReportDownloading: false
            }
        },
        methods: {
            onmount() {
                this.reportObject = {}
            },
            show() {
                document.getElementsByClassName('app-template')[0].classList.add('brief-builder-show')
            },
            open(reportType, availableData) {
                if (this.isDownloadingReport && this.previousReport) {
                    this.isPreviousReportDownloading = true
                }

                this.availableData = cloneDeep(availableData)
                this.reportType = reportType
                this.reportObject = cloneDeep(REPORT)

                if (reportType === 'city') {
                    this.reportObject.airport.hidden = true
                } else if (reportType === 'country') {
                    this.reportObject.airport.hidden = true
                    this.reportObject.city.hidden = true
                } else if (reportType === 'airspace') {
                    this.reportObject.airport.hidden = true
                    this.reportObject.city.hidden = true
                    this.reportObject.country.hidden = true
                }

                REPORT_FILTER.forEach(item => {
                    item.category.forEach(category => {
                        let airportBasicData = availableData['airportBasicData']
                        let covidImpactData = availableData['covidImpactRatings']
                        let cityRating = availableData?.['cityRating'] || airportBasicData?.['cityRating']
                        let medicalRating = availableData?.['medicalRating'] || airportBasicData?.['medicalRating']
                        let countryRating = availableData?.['countryRating'] || airportBasicData?.['countryRating']

                        if (availableData[item.value] && !availableData[item.value][category]) {
                            this.reportObject[item.key].categories[category].hidden = true
                        }

                        if (availableData[item.value]) {
                            if (item.key === 'city' && category === 'keyStats') {
                                const alertsLength = availableData[item.value]['alerts']?.length
                                this.reportObject[item.key].categories[category].items['activeAlerts'].hidden = alertsLength > 0 ? false : true
                                this.reportObject[item.key].categories[category].items['riskZoneRating'].hidden = cityRating ? false : true
                                if (alertsLength > 0 || cityRating) {
                                    this.reportObject[item.key].categories[category].hidden = false
                                }
                            }
                        }

                        if (item.key === 'airport' && category === 'keyStats' && this.reportType === 'airport') {
                            this.reportObject[item.key].categories[category].hidden = false

                            this.reportObject[item.key].categories[category].items['goNoGo'].hidden = airportBasicData.airportRating ? false : true
                            this.reportObject[item.key].categories[category].items['medicalRiskRating'].hidden = airportBasicData.medicalRating ? false : true
                            this.reportObject[item.key].categories[category].items['securityRiskRating'].hidden = airportBasicData.securityRating ? false : true
                            this.reportObject[item.key].categories[category].items['covidImpact'].hidden = (covidImpactData.travel || covidImpactData.domesticOperations) ? false : true
                        }

                        if (item.key === 'country' && category === 'keyStats') {
                            const alertsLength = availableData[item.value]['alerts']?.length
                            this.reportObject[item.key].categories[category].items['activeAlerts'].hidden = alertsLength > 0 ? false : true
                            this.reportObject[item.key].categories[category].items['travelRiskRating'].hidden = countryRating ? false : true
                            this.reportObject[item.key].categories[category].items['medicalRiskRating'].hidden = medicalRating ? false : true
                            this.reportObject[item.key].categories[category].items['covidImpact'].hidden = (covidImpactData.travel || covidImpactData.domesticOperations) ? false : true
                            if (alertsLength > 0 || countryRating || medicalRating) {
                                this.reportObject[item.key].categories[category].hidden = false
                            }
                        }

                        if (item.key === 'airspace' && category === 'keyStats') {
                            let airspaceDetails = availableData['airspaceDetails']
                            this.reportObject[item.key].categories[category].items['countryThreatTypes'].hidden = airspaceDetails.countryThreatTypes.length > 0 ? false : true
                            if (airspaceDetails.countryThreatTypes.length > 0) {
                                this.reportObject[item.key].categories[category].hidden = false
                            }
                        }

                        if (item.key === 'airspace' && category === 'czWarnings') {
                            const czWarningsLength = availableData?.airspaceDetails?.groupedRestrictions && Object.keys(availableData?.airspaceDetails?.groupedRestrictions)?.length || 0
                            this.reportObject[item.key].categories[category].items['czWarnings'].hidden = czWarningsLength > 0 ? false : true
                            this.reportObject[item.key].categories[category].hidden = czWarningsLength > 0 ? false : true
                        }

                        if (item.key === 'airspace' && category == 'aviation') {
                            this.reportObject[item.key].categories[category].items['aviationAlerts'].hidden = availableData?.airspaceDetails?.aviationAlerts?.length > 0 ? false : true
                        }

                        if (availableData[item.value] && availableData[item.value][category] && !Array.isArray(availableData[item.value][category])) {
                            for (const key in availableData[item.value][category]) {
                                const element = availableData[item.value][category][key]
                                if (this.reportObject[item.key].categories[category].items[key] === undefined) {
                                    console.warn('Could not find the key', key, 'inside the report object. Consider if this element should be added inside the reporting Brief Builder.')
                                } else {
                                    if (item.key === 'country' && category == 'travel' && key == 'securityAlerts') {
                                        this.reportObject[item.key].categories[category].items[key].hidden = element?.alerts?.length > 0 ? false : true
                                    }

                                    if (element === null || element === undefined || element === '' || element.length === 0) {
                                        this.reportObject[item.key].categories[category].items[key].hidden = true
                                    } else {
                                        this.reportObject[item.key].categories[category].items[key].hidden = false
                                    }
                                }

                                const subCategoryItem = Object.values(this.reportObject[item.key].categories[category].items)
                                const subCategoryHiddenItemsLength = subCategoryItem.filter(item => item.hidden === true).length
                                if (subCategoryHiddenItemsLength === subCategoryItem.length) {
                                    this.reportObject[item.key].categories[category].hidden = true
                                }

                            }
                        }
                    })
                    const subCategory = Object.values(this.reportObject[item.key].categories)
                    const subCategoryHiddenLength = subCategory.filter(item => item.hidden === true).length
                    if (subCategoryHiddenLength === subCategory.length) {
                        this.reportObject[item.key].hidden = true
                    }

                })

                User.getLocalUserSettings().then(userSettings => {
                    if (userSettings.briefBuilder === null) {
                        this.saveUserBriefBuilderSettings()
                    } else {
                        const savedBriefBuilderSettings = JSON.parse(userSettings.briefBuilder)
                        // Here we have previously saved user briefBuilder settings that all properties should correspond to our this.reportObject object
                        // But this.reportObject object might have more properties than the savedBriefBuilderSettings
                        // Loop through all properties and override the `enabled` property value, otherwise console.warn saying the property doesn't exist
                        for (const reportType in savedBriefBuilderSettings) {
                            if (this.reportObject[reportType] === undefined) {
                                console.warn('Could not find the report type', reportType, 'inside the report object. Consider if this element should be added inside the reporting Brief Builder.')
                            } else {
                                this.reportObject[reportType].enabled = savedBriefBuilderSettings[reportType].enabled
                                for (const category in savedBriefBuilderSettings[reportType].categories) {
                                    if (this.reportObject[reportType].categories[category] === undefined) {
                                        console.warn('Could not find the category', category, 'inside the report object. Consider if this element should be added inside the reporting Brief Builder.')
                                    } else {
                                        this.reportObject[reportType].categories[category].enabled = savedBriefBuilderSettings[reportType].categories[category].enabled
                                        for (const item in savedBriefBuilderSettings[reportType].categories[category].items) {
                                            if (this.reportObject[reportType].categories[category].items[item] === undefined) {
                                                console.warn('Could not find the item', item, 'inside the user report object. This will be added on the next time the user settings are updated. Or it is an old property that was saved on the user profile and will be removed.')
                                            } else {
                                                this.reportObject[reportType].categories[category].items[item].enabled = savedBriefBuilderSettings[reportType].categories[category].items[item].enabled
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                })
                this.show()
                setTimeout(() => {
                    this.enableDisableExportReportButton()
                }, 100);
            },
            saveUserBriefBuilderSettings() {
                const userBriefBuilderSettings = cloneDeep(this.reportObject)

                for (const reportType in userBriefBuilderSettings) {
                    delete userBriefBuilderSettings[reportType].hidden
                    for (const category in userBriefBuilderSettings[reportType].categories) {
                        delete userBriefBuilderSettings[reportType].categories[category].hidden
                        for (const item in userBriefBuilderSettings[reportType].categories[category].items) {
                            delete userBriefBuilderSettings[reportType].categories[category].items[item].hidden
                        }
                    }
                }

                User.updateUserBriefBuilderSettings(userBriefBuilderSettings)
            },
            resetData(item, category, subCategoryItem, finalData) {
                for (const items in subCategoryItem) {
                    if (!subCategoryItem[items].enabled) {
                        if (finalData[item.value]?.[category]?.[items])
                            finalData[item.value][category][items] = null
                    }
                }
            },
            selectMainCategory(category, index, type) {
                this.selectMainCategoryIndex = type + category.title + index
                this.selectedSubCategory = category
                this.selectedSubCategory.type = type
            },
            handleChangeMainCategory(category) {
                category.enabled = !category.enabled
                for (const item in category.items) {
                    category.items[item].enabled = category.enabled
                }
                this.handledEnabledDisableCategory()
            },
            handleChangeSubCategory(category) {
                category.enabled = !category.enabled
                this.handledEnabledDisableCategory()
            },
            handledEnabledDisableCategory() {
                for (const item in this.selectedSubCategory.items) {
                    if (this.selectedSubCategory.items[item].enabled && !this.selectedSubCategory.items[item].hidden) {
                        this.selectedSubCategory.enabled = true
                        break
                    } else {
                        this.selectedSubCategory.enabled = false
                    }
                }

                for (const item in this.reportObject) {
                    for (const category in this.reportObject[item].categories) {
                        if (this.reportObject[item].categories[category].enabled && !this.reportObject[item].categories[category].hidden) {
                            this.reportObject[item].enabled = true
                            break
                        } else {
                            this.reportObject[item].enabled = false
                        }
                    }
                }
                this.enableDisableExportReportButton()
            },
            hide(isHide) {
                if (isHide) {
                    document.getElementsByClassName('app-template')[0].classList.remove('brief-builder-show')
                } else {
                    this.selectMainCategoryIndex = ''
                    this.selectedSubCategory = {}
                    this.saveUserBriefBuilderSettings()
                    document.getElementsByClassName('app-template')[0].classList.remove('brief-builder-show')
                    if (this.$refs?.reportType?.length > 0) {
                        this.$refs?.reportType?.forEach(element => {
                            this.$nextTick(() => this.toggleAccordion(null, element, 'closeAll'))
                        })
                    }
                }
            },
            exportReport() {
                this.isDownloadingReport = true
                try {
                    const finalData = cloneDeep(this.availableData)
                    this.previousReport = `${this.availableData.countryName}-${this.availableData.cityName}`
                    let medicalRating = this.availableData?.['medicalRating'] || this.availableData?.['airportBasicData']?.['medicalRating']
                    let countryRating = this.availableData?.['countryRating'] || this.availableData?.['airportBasicData']?.['countryRating']
                    let cityRating = this.availableData?.['cityRating'] || this.availableData?.['airportBasicData']?.['cityRating']
                    let airportBasicData = finalData['airportBasicData']
                    let airportDetails = finalData['airportDetails']
                    let covidImpactData = finalData['covidImpactRatings']
                    let cityDetails = finalData['cityDetails']
                    let countryDetails = finalData['countryDetails']

                    REPORT_FILTER.forEach(item => {
                        item.category.forEach(category => {

                            if (item.key === 'airport' && category === 'keyStats' && this.reportType === 'airport') {
                                
                                airportDetails.keyStats = {}
                                const airportCategory = this.reportObject[item.key].categories[category].items
                                airportDetails.keyStats.airportRating = airportCategory['goNoGo'].enabled ? airportBasicData.airportRating : null
                                airportDetails.keyStats.medicalRating = airportCategory['medicalRiskRating'].enabled ? medicalRating : null
                                if (airportCategory['securityRiskRating'].enabled) {
                                    airportDetails.keyStats.securityRating = airportBasicData.securityRating
                                    airportDetails.keyStats.inheritedCityRating = airportBasicData.inheritedCityRating
                                }
                                airportDetails.keyStats.covidImpactData = airportCategory['covidImpact'].enabled ? covidImpactData : null
                            }

                            if (item.key === 'city' && category === 'keyStats' && ['airport', 'city'].includes(this.reportType)) {
                                const cityCategory = this.reportObject[item.key].categories[category].items
                                cityDetails.keyStats = {}
                                cityDetails.keyStats.riskZoneRating = cityCategory['riskZoneRating'].enabled ? cityRating : null
                            }

                            if ((item.key === 'city' && category === 'keyStats') || (item.key === 'country' && category === 'keyStats')) {
                                const cityCategory = this.reportObject['city'].categories[category].items
                                const countryCategory = this.reportObject['country'].categories[category].items
                                if (this.reportObject['city'].enabled && cityCategory['activeAlerts'].enabled && cityDetails) {
                                    finalData.cityDetails.totalAlerts = cityDetails.alerts?.length
                                    if (this.reportObject['country'].enabled && countryCategory['activeAlerts'].enabled) {
                                        finalData.alerts = countryDetails?.alerts || []
                                        finalData.countryDetails.totalAlerts = countryDetails.alerts?.length
                                    } else {
                                        finalData.alerts = cityDetails?.alerts || []
                                    }
                                } else {
                                    if (this.reportObject['country'].enabled && countryCategory['activeAlerts'].enabled) {
                                        finalData.alerts = countryDetails?.alerts || []
                                        finalData.countryDetails.totalAlerts = countryDetails.alerts?.length
                                    }
                                }
                            }

                            if (item.key === 'country' && category === 'keyStats' && ['airport', 'city', 'country'].includes(this.reportType)) {
                                countryDetails.keyStats = {}
                                const countryCategory = this.reportObject[item.key].categories[category].items
                                countryDetails.keyStats.travelRiskRating = countryCategory?.['travelRiskRating']?.enabled ? countryRating : null
                                countryDetails.keyStats.medicalRiskRating = countryCategory?.['medicalRiskRating']?.enabled ? medicalRating : null
                                countryDetails.keyStats.covidImpactData = countryCategory?.['covidImpact']?.enabled ? covidImpactData : null
                            }

                            if (item.key === 'airspace' && category === 'keyStats') {
                                finalData.airspaceDetails.keyStats = {}
                                let airspaceDetails = finalData?.['airspaceDetails']
                                const airspaceCategory = this.reportObject[item.key].categories[category].items
                                airspaceDetails.keyStats.countryThreatTypes = airspaceCategory?.['countryThreatTypes']?.enabled ? airspaceDetails?.countryThreatTypes : null
                            }

                            if (item.key === 'airspace' && category === 'czWarnings') {
                                let groupedRestrictions = []
                                if (this.reportObject[item.key].categories[category].items['czWarnings'].enabled) {
                                    for (const key in finalData?.airspaceDetails?.groupedRestrictions) {
                                        finalData.airspaceDetails?.groupedRestrictions?.[key]?.forEach(item => {
                                            groupedRestrictions.push(item)
                                        })
                                    }
                                } else {
                                    groupedRestrictions = null

                                }
                                finalData.airspaceDetails.groupedRestrictions = groupedRestrictions
                            }

                            if (item.key === 'airspace' && category === 'aviation') {
                                if (this.reportObject[item.key].categories[category].items['aviationAlerts'].enabled) {
                                    finalData.airspaceDetails?.aviationAlerts?.map(item => {
                                        item.alertType = 'Aviation'
                                    })
                                    finalData.alerts = [...finalData.alerts || [], ...finalData?.airspaceDetails?.aviationAlerts || []]
                                }
                            }

                            const maincategory = this.reportObject[item.key]
                            const subCategory = this.reportObject[item.key].categories[category]
                            const subCategoryItem = this.reportObject[item.key].categories[category]?.items
                            if (!subCategory?.enabled || !maincategory?.enabled) {
                                if (finalData[item.value]?.[category]) {
                                    this.resetData(item, category, subCategoryItem, finalData)
                                }
                            }
                            this.resetData(item, category, subCategoryItem, finalData)
                        })
                    })

                    finalData.alerts = finalData?.alerts?.filter(res => {
                        const alertDate = moment(res.createdDate)
                        const todayMinus72Hours = moment().subtract(72, 'hours')
                        
                        // Include alerts issued in the last 72 hours
                        const isWithin72Hours = alertDate.isAfter(todayMinus72Hours)
                        
                        const hasActiveFrom = res.activeFrom !== undefined && res.activeFrom !== null && res.activeFrom !== ''
                        const hasActiveTo = res.activeTo !== undefined && res.activeTo !== null && res.activeTo !== ''
                        const isInternationalSOSAlert = hasActiveFrom || hasActiveTo
                        const isAvsecAlert = !isInternationalSOSAlert && (res.type === 'avsec' || res.alertType === 'Aviation' || res.alertType === 'Aviation - Breaking')
                        
                        // For Avsec alerts, only include those from last 72 hours since we can't determine active status
                        if (isAvsecAlert) {
                            return isWithin72Hours
                        }
                        
                        // For InternationalSOS alerts, include if within 72 hours OR if currently active
                        // An alert is active if ActiveTo is null/undefined/empty OR if current time is before or equal to ActiveTo
                        // If ActiveFrom exists but ActiveTo is null, the alert should be included
                        if (isInternationalSOSAlert) {
                            // If activeTo is null/undefined/empty but activeFrom exists, consider it active
                            if (!hasActiveTo && hasActiveFrom) {
                                return true
                            }
                            // If activeTo exists, check if current time is before or equal to activeTo
                            if (hasActiveTo) {
                                const activeToDate = moment(res.activeTo)
                                const isActive = moment().isSameOrBefore(activeToDate)
                                return isWithin72Hours || isActive
                            }
                        }
                        
                        // Default: only include if within 72 hours
                        return isWithin72Hours
                    }) || []

                    if (airportDetails?.publishedDate) {
                        finalData.airportDetails.publishedDate = moment.utc(airportDetails.publishedDate).format('MM/DD/YYYY') + ' (UTC)'           
                    }
                    if (finalData?.airspaceDetails?.publishedDate) {
                        finalData.airspaceDetails.publishedDate = moment.utc(finalData.airspaceDetails.publishedDate).format('MM/DD/YYYY')+ ' (UTC)'
                    }

                    delete finalData?.countryDetails?.alerts
                    delete finalData?.cityDetails?.alerts
                    delete finalData?.airspaceDetails?.restrictions
                    delete finalData?.airspaceDetails?.aviationAlerts
                    delete finalData?.countryDetails?.travel?.travelRestrictions

                    const reportsType = Object.keys(this.reportObject).filter(res => !this.reportObject[res].hidden && this.reportObject[res].enabled)
                    if (!reportsType.includes('airport')) {
                        finalData.airportDetails = null
                        finalData.airportBasicData = null
                        finalData.covidImpactRatings = null
                    }
                    if (!reportsType.includes('city')) {
                        finalData.cityDetails = null
                    }
                    if (!reportsType.includes('country')) {
                        finalData.countryDetails = null
                    }
                    if (!reportsType.includes('airspace')) {
                        finalData.airspaceDetails = null
                    }

                    ClientPortalAPIService.downloadBriefBuilderReport(reportsType.toString(), JSON.stringify(finalData)).then(res => {
                        try {
                            if (res) {
                                const pdfBlob = new Blob([res], { type: 'application/pdf' })

                                // Create a URL for the Blob
                                const blobUrl = URL.createObjectURL(pdfBlob)

                                // Create a link and simulate clicking to trigger the download
                                const link = document.createElement('a')
                                link.href = blobUrl
                                link.download = 'report.pdf'
                                link.click()

                                // Clean up the Blob URL
                                URL.revokeObjectURL(blobUrl)
                            }
                            this.isDownloadingReport = false
                            this.previousReport = null
                            this.isPreviousReportDownloading = false

                        } catch (error) {
                            this.isDownloadingReport = false
                            this.isDownloadReportHasError = true
                            this.previousReport = null
                            this.isPreviousReportDownloading = false
                        }
                    }).catch(error => {
                        this.isDownloadingReport = false
                        this.isDownloadReportHasError = true
                        this.previousReport = null
                        this.isPreviousReportDownloading = false
                    }).finally(() => {
                        this.isDownloadingReport = false
                        this.previousReport = null
                        this.isPreviousReportDownloading = false
                    })
                    
                    MixPanelService.track('Download Report', {
                        'Report Name': 'Brief Builder',
                        'Source': 'Security Portal',
                        'Details': ``,
                        'Type': reportsType.join(', ')
                    })
                } catch (error) {
                    this.isDownloadingReport = false
                    this.isDownloadReportHasError = true
                    this.previousReport = null
                    this.isPreviousReportDownloading = false
                }

            },
            startExportReport() {
                this.saveUserBriefBuilderSettings()
                this.exportReport()

            },
            toggleAccordion(event, element, type) {
                let accordion = null

                if (element !== undefined) {
                    accordion = element
                } else {
                    accordion = event.target.parentElement
                }

                const contentContainer = accordion.getElementsByClassName('accordion__content-container')[0]
                const contentHeight = accordion.getElementsByClassName('accordion__content')[0].offsetHeight
                if (accordion.classList.contains('show-content') || type === "closeAll") {
                    accordion.classList.remove('show-content')
                    contentContainer.setAttribute('style', 'height: 0')
                } else {
                    accordion.classList.add('show-content')
                    contentContainer.setAttribute('style', 'height:' + (parseInt(contentHeight) + 16) + 'px')
                }
            },
            handleSelectAll(type) {
                // select all main and sub catagory enabled true
                for (const reportType in this.reportObject) {
                    this.reportObject[reportType].enabled = (type === 'all' ? true : false)
                    for (const category in this.reportObject[reportType].categories) {
                        for (const item in this.reportObject[reportType].categories[category].items) {
                            this.reportObject[reportType].categories[category].items[item].enabled = (type === 'all' ? true : false)
                        }
                        this.reportObject[reportType].categories[category].enabled = (type === 'all' ? true : false)
                    }
                }
                this.enableDisableExportReportButton()
            },
            handleChangeReportCategory(category) {
                category.enabled = !category.enabled
                for (const item in category.categories) {
                    category.categories[item].enabled = category.enabled
                    for (const item1 in category.categories[item].items) {
                        category.categories[item].items[item1].enabled = category.enabled
                    }
                }
                this.enableDisableExportReportButton()
            },
            enableDisableExportReportButton() {
                let selectedData = Object.values(this.reportObject).filter(item => item.enabled === true && !item.hidden)
                if (selectedData.length === 0) {
                    this.isExportButtonDisable = true
                } else {
                    this.isExportButtonDisable = false
                }
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-brief-builder')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();
